import * as yup from 'yup'
import { GUID_REGEX } from '../strings/yup-regex'

export const valueRequired = (field: string = 'This') =>
  yup.object().shape({
    value: yup.string().required(`${field} is a required field`),
  })

export const validGuidRequired = (field: string = 'This') =>
  yup.object().shape({
    value: yup.string().required(`${field} is a required field`).matches(GUID_REGEX, `Invalid ${field}`),
  })

export const validEmailRequired = (field: string = 'email') =>
  yup.object().shape({
    value: yup.string().email(`Invalid ${field == '' ? 'email' : field}`),
  })

export const validMinLength = (field: string = 'This', length: number) =>
  yup.object().shape({
    value: yup.string().min(length, `${field} must not be less than ${length} characters`),
  })

export const validMaxLength = (field: string = 'This', length: number) =>
  yup.object().shape({
    value: yup.string().max(length, `${field} must not be greater than ${length} characters`),
  })

export const createPolicySchema = yup.object().shape({
  name: yup.string().required('Policy name is required'),
  description: yup.string().optional(),
})
